



























































import { Component, Prop, Vue } from "vue-property-decorator";
import { IAccount } from "@/models/accounts";
import { IClient } from "@/models/clients";
import AffiliateProvider from "@/components/app/global/affiliate/affiliateProvider.vue";
@Component({
  components: {
    AffiliateProvider
  }
})
export default class ClientAffiliateView extends Vue {
  // Refs
  public $refs!: {
    affiliateProvider: AffiliateProvider;
  };

  // Props
  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: false })
  public client!: IClient;

  // Methods
  public onRefresh() {
    this.$emit("refresh");
    this.$refs.affiliateProvider.reloadData();
  }
}
